import React, { Fragment, useEffect, useState, Suspense, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { AppLogo } from "../../app-logo";
import { MenuItem } from "../../menu-item";
import { Link } from "@quintype/components";
import { NavbarSearch } from "../navbar-search";
import useViewPort from "../../../../hook/useViewPort";
import { HamburgerMenuItem } from "../../hamburger-menu-item";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import MessageWrapper from "../../../molecules/forms/message-wrapper";
import { getOauthAuthorizeUrl, getAutoSSOUrl } from "@quintype/bridgekeeper-js";
import { TopHeaderChannelDropdown } from "../top-bar/top-bar-channels-dropdown";
import {
  OPEN_HAMBURGER_MENU,
  OPEN_SEARCHBAR,
  MEMBER_UPDATED,
  RADIOT_CLICKED,
  RADIOT_HELSINKI,
  RADIOT_YLEISOHJELMA,
  RADIOT_KAJANI,
  RADIOT_KEMI,
  RADIOT_TORNIO,
  RADIOT_KOKKOLA,
  RADIOT_KRISTIINANKAUPPUNKI,
  RADIOT_TURKU,
  RADIOT_OULU,
  RADIOT_ROVANIEMI,
  RADIOT_LAHTI,
  RESET_ALL_RADIO_PLAYERS,
} from "../../../store/actions";
import "./navbar.m.css";

const NavBar = () => {
  // Import account modal dynamically
  const AccountModal = lazy(() => import("../../../login/AccountModal"));
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showChildren, setShowChildren] = useState(false);
  const [navToggleSmallScreen, setNavToggleSmallScreen] = useState(false);
  const [menubarRadio, setMenubarRadio] = useState(false);
  const dispatch = useDispatch();
  const [showUserHandler, setUserHandler] = useState(false);
  const getState = useSelector((state) => state);
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtState, ["currentPath"], "");
  const { viewports } = useViewPort();
  let menuDataToLoad = "navigationMenu";
  if (currentPath === "/lammas") {
    menuDataToLoad = "channelOneNavigationMenu";
  } else {
    menuDataToLoad = "navigationMenu";
  }
  const publisherAttributes = get(getState, ["qt", "config", "publisher-attributes"], {});
  const enableLogin = get(publisherAttributes, ["enableLogin"], true);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const menu = get(getState, ["qt", "data", menuDataToLoad, "default"], []);
  const hamburgerMenu = get(getState, ["qt", "data", menuDataToLoad, "hamburgerMenu"], []);
  const displayStyle = isHamburgerMenuOpen ? "grid" : "none";
  const domainSlug = get(getState, ["qt", "config", "domainSlug"], "");
  const clientId = get(publisherAttributes, ["sso_login", "client_id"], "");
  const redirectUrl = domainSlug
    ? get(publisherAttributes, ["sso_login", "subdomain", domainSlug, "redirect_Url"], "")
    : get(publisherAttributes, ["sso_login", "redirect_Url"], "");

  const ssoLoginIsEnable = get(publisherAttributes, ["sso_login", "is_enable"], false);
  const isAutoSSOEnabled = get(publisherAttributes, ["auto_sso", "is_enable"], false);
  const handleNavToggleSmallScreen = () => setNavToggleSmallScreen(!navToggleSmallScreen);
  const [navSelected, setNavSelected] = useState(null);
  useEffect(() => {
    if (menu && menu?.length > 0) {
      const activeItem = menu.find(
        (item) =>
          item.url === currentPath ||
          item.completeUrl === currentPath ||
          (item.completeUrl && item.completeUrl.endsWith(currentPath))
      );
      if (activeItem) {
        setNavSelected(activeItem.title);
      }
    }
  }, [currentPath, menu]);

  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen,
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
  };
  const handleMouseEnter = () => {
    setShowChildren(true);
  };

  const handleMouseLeave = () => {
    setShowChildren(false);
  };
  const userAccountHandler = () => {
    setUserHandler(!showUserHandler);
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
  };

  const getCurrentUser = async () => {
    // Import current user function only when this function is called
    const { currentUser } = await import("@quintype/bridgekeeper-js");
    try {
      const currentUserResp = await currentUser();
      dispatch({ type: MEMBER_UPDATED, member: get(currentUserResp, ["user"], null) });
      return currentUserResp;
    } catch (err) {
      console.log("error--------", err);
    }
  };

  const logoutHandler = async () => {
    // Import logout on click of the logout button
    const { logout } = await import("@quintype/bridgekeeper-js");
    logout()
      .then(() => {
        dispatch({
          type: MEMBER_UPDATED,
          member: null,
        });
      })
      .finally(() => {
        setShowAccountModal(false);
        setUserHandler(false);
        window.location.href = "/";
      });
  };

  const userBtnClick = () => {
    setShowAccountModal(true);
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
  };
  const handleMouseEnterRadiot = () => setMenubarRadio(!menubarRadio);
  const handleMouseLeaveRadiot = () => setMenubarRadio(false);

  const getNavbarMenu = (menu) => {
    return (
      <div styleName="navbar">
        {menu.length > 0 &&
          menu.map((item) => {
            return (
              <div
                key={item.id}
                styleName="dropdown"
              >
                <MenuItem
                  item={item}
                  menuStyle="menu-link"
                  navSelected={navSelected}
                  setNavSelected={setNavSelected}
                  toggleHandler={() => {
                    dispatch({
                      type: RADIOT_CLICKED,
                      isRadiotClicked: true,
                    });
                  }}
                />
              </div>
            );
          })}
      </div>
    );
  };
  const getNavbarMenuMob = (menu) => {
    return (
      <React.Fragment>
        <div styleName="navbar-mob-container">
          <div styleName="navbar-mob">
            <div>
              {menu.length > 0 &&
                menu.slice(1).map((item) => {
                  return (
                    <div key={item.id} styleName="dropdown-mob">
                      <MenuItem
                        item={item}
                        menuStyle="menu-link"
                        navSelected={navSelected}
                        setNavSelected={setNavSelected}
                        toggleHandler={() =>
                          dispatch({
                            type: OPEN_SEARCHBAR,
                            isSearchBarOpen: false,
                          })
                        }
                      />
                    </div>
                  );
                })}
            </div>
          </div>
          <div styleName="second-col-wrapper">
            {/* <div>
              <TopHeaderChannelDropdown navSelected={navSelected} setNavSelected={setNavSelected} />
            </div> */}
            {/*<Link href="/subscription" styleName="subscribe-btn-mob">
              <div
                styleName={`nav-item-kanavat ${navSelected === "subscription-mob" ? "active" : ""}`}
                onClick={() => setNavSelected("subscription-mob")}
              >
                <span styleName="nav-item-tilaa">
                  TILAA DEI PLUS
                </span>
              </div>
            </Link>*/}
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getDropdownList = () => {
    if (!isHamburgerMenuOpen) {
      return null;
    }
    return (
      <Fragment>
        <div styleName="overlay" onClick={() => toggleHandler()}></div>
        <div className="">
          <ul styleName="dropdown-content" style={{ display: displayStyle }}>
            {/*<HamburgerMenu onMenuToggle={() => toggleHandler()} isMegaMenuOpen={isHamburgerMenuOpen} />*/}
            {hamburgerMenu.length > 0 &&
              hamburgerMenu.map((item) => {
                return (
                  <li
                    key={item.title}
                    styleName="dropdown"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <HamburgerMenuItem menuStyle="menu-link" item={item} toggleHandler={() => toggleHandler()} />
                    {showChildren &&
                      item.children.length > 0 &&
                      item.children.map((child) => (
                        <ul style={{ display: displayStyle }}>
                          <li key={child.title} styleName="dropdown">
                            <HamburgerMenuItem
                              menuStyle="menu-link"
                              item={child}
                              toggleHandler={() => toggleHandler()}
                            />
                          </li>
                        </ul>
                      ))}
                  </li>
                );
              })}
          </ul>
        </div>
      </Fragment>
    );
  };
  /** get expanded navigation items start */
  const getNavLists = () => {
    if (!isHamburgerMenuOpen) {
      return null;
    }
    return (
      <Fragment>
        <div styleName="expanded-nav">
          <div styleName="nav-contents">
            <ul styleName="menu-columns">
              {hamburgerMenu.length > 0 &&
                hamburgerMenu.map((item) => (
                  <li key={item.title} styleName="menu-parent">
                    <HamburgerMenuItem menuStyle="menu-link" item={item} toggleHandler={() => toggleHandler()} />
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </Fragment>
    );
  };
  /** get expanded navigation items end */
  const member = useSelector((state) => get(state, ["member"], null));
  const imageUrl = member && member["avatar-url"];
  const userName = (member && member.name) || "Khem Neupane"; //remove hardcoded name later.
  const nameArray = userName.split(" ");
  const nameInitials = nameArray.map((word) => word[0]).join("");
  //const nameInitials= initials.toUpperCase();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryParamExists = queryParams.has("logged_in");

    getCurrentUser().then(({ user }) => {
      if (isAutoSSOEnabled && !user && !queryParamExists) {
        const autoSsoUrl = getAutoSSOUrl(clientId, redirectUrl, window.location.href);
        window.location.replace(autoSsoUrl);
      }
    });

    switch (global.location.hash) {
      case "#email-verified":
        window.location.href = "/user-login";
        break;
      case "#token-consumed":
        return setMessage("The verification link is already used.");
      case "#invalid-token":
        return setMessage("The verification link is invalid. Please request for a new link.");
      case "#internal-error":
        return setMessage("Something went wrong. Please try again.");
      default:
        return setMessage(null);
    }
  }, []);

  const userLogin = (loading) => {
    setLoading(loading);
    if (window) {
      const oauthAuthorizeUrl = getOauthAuthorizeUrl(clientId, redirectUrl, window.location.href);
      window.location.replace(oauthAuthorizeUrl);
    }
  };

  const messageModal = (message) => {
    // Import modal on message
    const Modal = lazy(() => import("../../../login/modal"));
    return (
      <Suspense fallback={<div></div>}>
        <Modal onClose={() => setMessage(null)}>
          <MessageWrapper message={message} />
        </Modal>
      </Suspense>
    );
  };
  let homepageSlug = "";
  if (currentPath.startsWith("/lammas")) {
    homepageSlug = "/";
  } else {
    homepageSlug = "/";
  }

  return (
    <div styleName="main-wrapper" id="sticky-navbar" onMouseLeave={() => setNavToggleSmallScreen(false)}>
      <nav className={viewports ? viewports : ""} styleName="wrapper">
        <div styleName="first-block">
          <div>
            <AppLogo />
          </div>
          {/* <Link href="/kanavat" styleName="link-style">
            <div
              styleName={`nav-item-kanavat ${navSelected === "kanavat" ? "active" : ""}`}
              onClick={() => {
                setNavSelected("kanavat");
                dispatch({
                  type: RADIOT_HELSINKI,
                  isRadiotHelsinkiClicked: false,
                });
                dispatch({
                  type: RADIOT_LAHTI,
                  isRadiotLahtiClicked: false,
                });
                dispatch({
                  type: RADIOT_ROVANIEMI,
                  isRadiotRovaniemiClicked: false,
                });
                dispatch({
                  type: RADIOT_OULU,
                  isRadiotOuluClicked: false,
                });
                dispatch({
                  type: RADIOT_YLEISOHJELMA,
                  isRadiotYleisohjelmaClicked: false,
                });
                dispatch({
                  type: RADIOT_KAJANI,
                  isRadiotKajaniClicked: false,
                });
                dispatch({
                  type: RADIOT_TURKU,
                  isRadiotTurkuClicked: false,
                });
                dispatch({
                  type: RADIOT_KEMI,
                  isRadiotKemiClicked: false,
                });
                dispatch({
                  type: RADIOT_TORNIO,
                  isRadiotTornioClicked: false,
                });
                dispatch({
                  type: RADIOT_KOKKOLA,
                  isRadiotKokkolaClicked: false,
                });
                dispatch({
                  type: RADIOT_KRISTIINANKAUPPUNKI,
                  isRadiotKristiinankauppunkiClicked: false,
                });
              }}
            >
              KANAVAT
            </div>
          </Link> */}

          {getNavbarMenu(menu)}
          {navToggleSmallScreen && getNavbarMenuMob(menu)}
          {
            <div styleName="nav-i">
              {menu && menu.length > 0 && (
                <div styleName="mobile-first-item" style={{ marginRight: "15px" }}>
                  <MenuItem
                    item={menu[0]}
                    menuStyle="menu-link"
                    navSelected={navSelected}
                    setNavSelected={setNavSelected}
                    toggleHandler={() => {
                      dispatch({
                        type: RADIOT_CLICKED,
                        isRadiotClicked: true,
                      });
                    }}
                  />
                </div>
              )}
              <span
                onClick={() => {
                  handleNavToggleSmallScreen();
                  dispatch({ type: RESET_ALL_RADIO_PLAYERS });
                }}
              >
                VALIKKO
              </span>
              <i
                onClick={() => {
                  handleNavToggleSmallScreen();
                  dispatch({ type: RESET_ALL_RADIO_PLAYERS });
                }}
                class="ri-arrow-drop-down-line"
              ></i>
            </div>
          }
        </div>

        <div styleName="second-block">
          <NavbarSearch />
          {/*
            <Link href="/subscription" styleName="link-style subscribe-btn">
              <div
                styleName={`nav-item-kanavat ${navSelected === "subscription" ? "active" : ""}`}
                onClick={() => setNavSelected("subscription")}
              >
                TILAA DEI PLUS
              </div>
            </Link>
          */}
          {enableLogin ? (
            <div styleName="user-profile">
              {member && (member["verification-status"] || member.id) ? (
                <>
                  {imageUrl ? (
                    <img
                      width="24"
                      height="24"
                      alt="user"
                      src={imageUrl}
                      styleName="member-img"
                      onClick={userAccountHandler}
                    />
                  ) : (
                    <>
                      <div styleName="user-initials">
                        <div styleName="initials-circle" onClick={userAccountHandler}>
                          {nameInitials}
                        </div>
                        <div styleName="full-name">{userName}</div>
                      </div>
                    </>
                  )}
                  {showUserHandler && (
                    <div styleName="user-dropdown-wrapper">
                      <div styleName="overlay" onClick={userAccountHandler}></div>
                      <ul styleName="dropdown-content user-account">
                        <Link
                          styleName="user-account-item"
                          callback={() => setUserHandler(!showUserHandler)}
                          href="/profile"
                          aria-label="user-account-item"
                        >
                          <div
                            styleName={`nav-item-kanavat ${navSelected === "profile" ? "active" : ""}`}
                            onClick={() => setNavSelected("profile")}
                          >
                            Profiili
                          </div>
                        </Link>
                        <li styleName="user-account-item" onClick={logoutHandler}>
                          <div
                            styleName={`nav-item-kanavat ${navSelected === "logout" ? "active" : ""}`}
                            onClick={() => setNavSelected("logout")}
                          >
                            kirjaudu ulos
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {!ssoLoginIsEnable ? (
                    <button aria-label="User Login Button" styleName="user-btn" onClick={() => userBtnClick()}>
                      <SvgIconHandler type="user-icon" width="18" height="20" viewBox="0 0 18 20" />
                    </button>
                  ) : !loading ? (
                    <a styleName="user-btn" onClick={() => userLogin(true)}>
                      <i class="ri-user-fill"></i>
                      {/*<SvgIconHandler iconStyle={{fill:"blue",stroke:"gren"}}  type="user-icon" width="18" height="20" viewBox="0 0 18 20" />*/}
                    </a>
                  ) : (
                    <span>Loading...</span>
                  )}

                  {showAccountModal && (
                    <Suspense fallback={<div></div>}>
                      <AccountModal onClose={() => setShowAccountModal(false)} />
                    </Suspense>
                  )}
                </>
              )}
            </div>
          ) : (
            <span></span>
          )}
        </div>
        {message && messageModal(message)}
      </nav>
      <div></div>
    </div>
  );
};

export { NavBar };
